import { render, staticRenderFns } from "./RouteBranch.vue?vue&type=template&id=e222f324&"
import script from "./RouteBranch.vue?vue&type=script&lang=js&"
export * from "./RouteBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports